"use client";
import {
	Avatar,
	AvatarFallback,
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@layer/ui/components";
import { cn } from "@layer/utils/cn";
import { getInitials } from "@layer/utils/formatters";
import { signOut, useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import type { AuthSessionType } from "@/types/auth.types";

const UserDropdown = () => {
	const session = useSession();
	const t = useTranslations("Navigation.userDropdown");
	if (!session) return;
	const { user } = session.data as AuthSessionType;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="outline"
					size="icon"
					className={cn("size-8", "rounded-full")}
				>
					<Avatar className="hover:border-primary-solid h-8 w-8 border text-sm">
						<AvatarFallback>
							{getInitials(user?.name ?? "")}
						</AvatarFallback>
					</Avatar>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-56">
				<DropdownMenuLabel>{t("title")}</DropdownMenuLabel>
				<DropdownMenuItem>
					{t("signedInAs")} &nbsp;
					<span className="text-primary-text font-mono">
						{user?.name?.toUpperCase()}
					</span>
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => signOut()}>
					{t("signOut")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { UserDropdown };
